import careersBreadcrumbImg from "@assets/images/other-pages/careers-3.webp";
import { PageHeader } from "@design-system/components";
import { trans } from "@mongez/localization";
import { careersBreadcrumb } from "../data";

export function CareersHeader() {
  return (
    <PageHeader
      translationKey="careersPage.title"
      breadcrumbItems={careersBreadcrumb}
      image={careersBreadcrumbImg}
      imageAlt={trans("careersPage.imageAlt")}
      contentClassName="text-2xl font-light leading-[33px] opacity-80 pb-20"
    >
      <div className="flex w-full flex-wrap items-center justify-between gap-10 lg:flex-nowrap">
        <div className="flex w-full flex-col gap-1 xl:w-[610px]">
          <h4 className="text-xs font-semibold text-bright-orange sm:text-sm lg:text-base">
            {trans("careersPage.careersAtSenaat")}
          </h4>
          <h2 className="text-2xl font-semibold sm:text-3xl lg:text-4xl">
            {trans("careersPage.careersAtSenaatSubtitle")}
          </h2>
        </div>

        {/* <div className="flex flex-col gap-6 text-sm text-white/90 sm:text-base lg:text-lg px-5">
          <p className="font-light">
            {trans("careersPage.content.paragraph1")}
          </p>
          <p className="font-light max-xl:pe-4">
            {trans("careersPage.content.paragraph2")}
          </p>
        </div> */}
      </div>
    </PageHeader>
  );
}
